/**
 * Auto-generated from dark-roast enum types — string-literal union types
 * derived from the Java backend's wire enum values. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

export enum AvailabilityPreferencesUpdatedByType {
  TALENT = "TALENT",
  HQ = "HQ",
}

export const AvailabilityPreferencesUpdatedByTypeDisplay: Record<AvailabilityPreferencesUpdatedByType, string> = {
  [AvailabilityPreferencesUpdatedByType.TALENT]: "Talent",
  [AvailabilityPreferencesUpdatedByType.HQ]: "HQ",
};
